import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Is this a dating app?',
  a: "No. It's a container for people you're already talking to. We don't have a feed, profiles to swipe, or a discovery mode. You invite someone via link."
}, {
  q: 'Do we have to chat inside the app?',
  a: 'Your choice. Chat in FlingLink or keep it on your socials (Insta, WhatsApp, Snap—wherever). FlingLink just adds the daily prompt and weekly decision. Total flexibility.'
}, {
  q: 'What if someone declines the invite?',
  a: 'Then you got your answer early. Low pressure, high clarity. Better to know now than in 3 weeks, right?'
}, {
  q: 'Is this private?',
  a: "100%. No public profiles. Your data is yours. If you delete a fling, it's gone forever."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-white" data-id="element-43">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-44">
        <h2 className="text-3xl font-bold mb-12 text-center" data-id="element-45">Questions?</h2>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, i) => <div key={i} className="border rounded-2xl overflow-hidden" data-id="element-47">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-48">
                <span className="font-bold text-lg" data-id="element-49">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-50" />
              </button>
              <AnimatePresence data-id="element-51">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-52">
                    <div className="p-6 pt-0 text-muted-foreground leading-relaxed" data-id="element-53">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}